module.exports = {
  "/": {
    "name": "index-redirect"
  },
  "/account-defaults": {
    "name": "account-defaults-redirect"
  },
  "/account-defaults/general": {
    "success": [
      "LANGUAGE_CHOOSER",
      "LOCALE_CHOOSER",
      "TIME_ZONE",
      "CURRENCY",
      "GDPR_COMPLIANCE"
    ],
    "error": [
      "LANGUAGE_CHOOSER_FAILURE",
      "LOCALE_CHOOSER_FAILURE",
      "TIME_ZONE_FAILURE",
      "CURRENCY_FAILURE",
      "GDPR_COMPLIANCE_FAILURE"
    ]
  },
  "/account-defaults/multicurrency": {
    "success": [
      "MULTI_CURRENCY_LOADED"
    ],
    "error": [
      "MULTI_CURRENCY_LOADED_FAILURE"
    ]
  },
  "/account-defaults/branding": {
    "success": [
      "BRANDING_COMPANY_INFO_LOADED"
    ],
    "error": [
      "BRANDING_COMPANY_INFO_LOADED_FAILURE"
    ]
  },
  "/account-defaults/branding/logo": {
    "success": [
      "BRANDING_COMPANY_LOGO_LOADED",
      "BRANDING_COMPANY_AVATAR_LOADED"
    ],
    "error": [
      "BRANDING_COMPANY_LOGO_LOADED_FAILURE",
      "BRANDING_COMPANY_AVATAR_LOADED_FAILURE"
    ]
  },
  "/account-defaults/branding/colors": {
    "success": [
      "BRANDING_COLORS_LOADED"
    ],
    "error": [
      "BRANDING_COLORS_LOADED_FAILURE"
    ]
  },
  "/goals": {
    "success": [
      "QUOTAS_LOADED"
    ]
  },
  "/analytics-and-tracking": {
    "name": "analytics-and-tracking-redirect"
  },
  "/analytics-and-tracking/tracking": {
    "name": "analytics-and-tracking-index",
    "success": [
      "ANALYTICS_AND_TRACKING_PAGE_LOADED"
    ]
  },
  "/analytics-and-tracking/domains": {
    "success": [
      "ADDITIONAL_DOMAINS_LOADED",
      "DOMAIN_CONFIGURATION_LOADED",
      "EXCLUDED_TRAFFIC_LOADED"
    ],
    "error": [
      "ADDITIONAL_DOMAINS_LOADED_FAILURE",
      "DOMAIN_CONFIGURATION_LOADED_FAILURE",
      "EXCLUDED_TRAFFIC_LOADED_FAILURE"
    ]
  },
  "/analytics-and-tracking/analytics-views": {
    "success": [
      "ANALYTICS_VIEWS_LOADED"
    ]
  },
  "/analytics-and-tracking/cookies": {
    "success": [
      "COOKIE_POLICY_LOADED"
    ],
    "error": [
      "COOKIE_POLICY_LOADED_FAILURE"
    ]
  },
  "/content-membership": {
    "name": "content-membership-redirect"
  },
  "/content-membership/:domainId": {
    "name": "content-membership-redirect"
  },
  "/content-membership/:domainId/general": {
    "success": [
      "CONTENT_MEMBERSHIP_LOADED"
    ],
    "error": [
      "CONTENT_MEMBERSHIP_LOADED_FAILURE"
    ]
  },
  "/content-membership/:domainId/templates": {
    "success": [
      "CONTENT_MEMBERSHIP_LOADED"
    ],
    "error": [
      "CONTENT_MEMBERSHIP_LOADED_FAILURE"
    ]
  },
  "/marketing/domains/languageSettings": {
    "success": [
      "LANGUAGE_SETTINGS_LOADED"
    ],
    "error": [
      "LANGUAGE_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/marketing/domains/sitemaps": {
    "success": [
      "SITEMAPS_LOADED"
    ]
  },
  "/marketing/domains/sitemaps/:domainId": {
    "success": [
      "SITEMAPS_LOADED"
    ],
    "error": [
      "SITEMAPS_LOADED_FAILURE"
    ]
  },
  "/ecommerce": {
    "name": "ecommerce",
    "success": [
      "ECOMMERCE_SETTINGS_LOADED"
    ],
    "error": [
      "ECOMMERCE_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/marketing/ads/adAccounts": {
    "name": "marketing-ads-adAccounts",
    "success": [
      "ADS_ACCOUNTS_LOADED"
    ],
    "error": [
      "ADS_ACCOUNTS_LOADED_FAILURE"
    ]
  },
  "/marketing/ads/leadSyncing": {
    "name": "marketing-ads-leadSyncing",
    "success": {
      "empty state": [
        "ADS_ACCOUNTS_EMPTY_STATE_LOADED"
      ],
      "content loaded": [
        "LEAD_SYNCING_LOADED"
      ]
    },
    "error": [
      "ADS_ACCOUNTS_LOADED_FAILURE",
      "LEAD_SYNCING_LOADED_FAILURE"
    ]
  },
  "/marketing/ads/pixels": {
    "name": "marketing-ads-pixels",
    "success": {
      "empty state": [
        "ADS_ACCOUNTS_EMPTY_STATE_LOADED"
      ],
      "content loaded": [
        "ADS_PIXELS_LOADED"
      ]
    },
    "error": [
      "ADS_PIXELS_LOADED_FAILURE",
      "ADS_ACCOUNTS_LOADED_FAILURE"
    ]
  },
  "/marketing/ads/roiCalculation": {
    "name": "marketing-ads-roiCalculation",
    "success": {
      "empty state": [
        "ADS_ACCOUNTS_EMPTY_STATE_LOADED"
      ],
      "content loaded": [
        "ROI_CALCULATION_LOADED"
      ]
    },
    "error": [
      "ROI_CALCULATION_LOADED_FAILURE",
      "ADS_ACCOUNTS_LOADED_FAILURE"
    ]
  },
  "/marketing/email": {
    "name": "marketing-email-index"
  },
  "/marketing/email/configuration": {
    "name": "marketing-email-configuration",
    "success": {
      "no access": [
        "EMAIL_SETTINGS_NO_ACCESS_LOADED"
      ],
      "content loaded": [
        "EMAIL_SETTINGS_LOADED",
        "EMAIL_FOOTER_LOADED"
      ]
    },
    "error": [
      "EMAIL_SETTINGS_LOADED_FAILURE",
      "EMAIL_FOOTER_LOADED_FAILURE"
    ]
  },
  "/marketing/email/double-opt-in": {
    "name": "marketing-email-double-opt-in",
    "success": {
      "no access": [
        "EMAIL_SETTINGS_LOADED"
      ],
      "content loaded": [
        "DOUBLE_OPT_IN_SETTINGS_LOADED"
      ]
    },
    "error": [
      "EMAIL_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/marketing/email/smtp": {
    "name": "marketing-email-smtp",
    "success": [
      "SMTP_SETTINGS_LOADED"
    ],
    "error": [
      "EMAIL_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/marketing/email/subscriptions": {
    "name": "marketing-email-subscriptions",
    "success": [
      "BCC_EMAIL_SETTINGS_LOADED",
      "SUBSCRIPTION_SETTINGS_LOADED",
      "RESUBSCRIPTION_EMAIL_SETTINGS_LOADED"
    ],
    "error": [
      "EMAIL_SETTINGS_LOADED_FAILURE",
      "BCC_EMAIL_SETTINGS_LOADED_FAILURE",
      "SUBSCRIPTION_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/marketing/email/tracking": {
    "name": "marketing-email-tracking",
    "success": [
      "TRACKING_SETTINGS_LOADED"
    ],
    "error": [
      "EMAIL_SETTINGS_LOADED_FAILURE",
      "TRACKING_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/marketing/email/types": {
    "name": "marketing-email-types",
    "success": [
      "EMAIL_TYPES_LOADED"
    ],
    "error": [
      "EMAIL_TYPES_LOADED_FAILURE",
      "EMAIL_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/marketing/email/frequency": {
    "name": "marketing-email-frequency",
    "success": [
      "SEND_FREQUENCY_LOADED"
    ],
    "error": [
      "EMAIL_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/marketing/email-service-provider": {
    "name": "marketing-email-service-provider",
    "success": [
      "ESP_SYNC_LOADED"
    ]
  },
  "/marketing/form": {
    "name": "marketing-form-redirect"
  },
  "/marketing/form/non-hubspot": {
    "name": "marketing-form-non-hubspot",
    "success": [
      "COLLECTED_FORMS_SETTINGS_LOADED"
    ],
    "error": [
      "COLLECTED_FORMS_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/marketing/form/styles": {
    "name": "marketing-form-styles",
    "success": [
      "FORM_STYLE_LOADED"
    ],
    "error": [
      "FORM_STYLE_LOADED_FAILURE"
    ]
  },
  "/marketing/form/submissionssettings": {
    "name": "marketing-form-submissionssettings",
    "success": [
      "FORM_SUBMISSIONS_SETTINGS_LOADED"
    ],
    "error": [
      "FORM_SUBMISSIONS_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/sales/meetings": {
    "name": "sales-meetings",
    "success": {
      "empty state": [
        "MEETINGS_EMTPY_STATE_LOADED"
      ]
    }
  },
  "/sales/meetings/calendar": {
    "name": "sales-meetings-calendar",
    "success": {
      "empty state": [
        "MEETINGS_EMTPY_STATE_LOADED"
      ],
      "content loaded": [
        "MEETINGS_SETTINGS_LOADED"
      ]
    }
  },
  "/sales/meetings/domain": {
    "name": "sales-meetings-domain",
    "success": {
      "empty state": [
        "MEETINGS_EMTPY_STATE_LOADED"
      ],
      "content loaded": [
        "MEETINGS_SETTINGS_LOADED"
      ]
    }
  },
  "/sales/meetings/integration": {
    "name": "sales-meetings-integration",
    "success": {
      "empty state": [
        "MEETINGS_EMTPY_STATE_LOADED"
      ]
    }
  },
  "/sales/products": {
    "success": [
      "PRODUCTS_LOADED"
    ],
    "error": [
      "PRODUCTS_LOADED_FAILURE"
    ]
  },
  "/sales/products/quotes": {
    "name": "sales-products-quotes",
    "success": [
      "PRODUCTS_LOADED"
    ],
    "error": [
      "PRODUCTS_LOADED_FAILURE"
    ]
  },
  "/website/blogs": {
    "success": [
      "BLOG_SETTINGS_LOADED"
    ],
    "error": [
      "BLOG_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/website/blogs/:blogId": {
    "success": [
      "BLOG_SETTINGS_LOADED"
    ],
    "error": [
      "BLOG_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/website/blogs/:blogId/default": {
    "success": [
      "BLOG_SETTINGS_LOADED"
    ],
    "error": [
      "BLOG_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/website/blogs/:blogId/comments": {
    "success": [
      "BLOG_SETTINGS_LOADED"
    ],
    "error": [
      "BLOG_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/website/blogs/:blogId/dateFormats": {
    "success": [
      "BLOG_SETTINGS_LOADED"
    ],
    "error": [
      "BLOG_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/website/blogs/:blogId/googleAmp": {
    "success": [
      "BLOG_SETTINGS_LOADED"
    ],
    "error": [
      "BLOG_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/website/blogs/:blogId/socialSharing": {
    "success": [
      "BLOG_SETTINGS_LOADED"
    ],
    "error": [
      "BLOG_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/website/blogs/:blogId/subscriptions": {
    "success": [
      "BLOG_SETTINGS_LOADED"
    ],
    "error": [
      "BLOG_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/website/blogs/:blogId/templates": {
    "success": [
      "BLOG_SETTINGS_LOADED"
    ],
    "error": [
      "BLOG_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/website/pages": {
    "name": "website-pages-redirect"
  },
  "/website/pages/all-domains": {
    "name": "website-pages-redirect"
  },
  "/website/pages/:domainId/branding": {
    "success": [
      "SITE_SETTINGS_LOADED"
    ],
    "error": [
      "SITE_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/website/pages/:domainId/integrations": {
    "success": [
      "SITE_SETTINGS_LOADED"
    ],
    "error": [
      "SITE_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/website/pages/:domainId/page-templates": {
    "success": [
      "SITE_SETTINGS_LOADED"
    ],
    "error": [
      "SITE_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/website/pages/:domainId/personalization": {
    "success": [
      "SITE_SETTINGS_LOADED"
    ],
    "error": [
      "SITE_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/website/pages/:domainId/seo-and-crawlers": {
    "success": [
      "SITE_SETTINGS_LOADED"
    ],
    "error": [
      "SITE_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/website/pages/:domainId/system-pages": {
    "success": [
      "SITE_SETTINGS_LOADED"
    ],
    "error": [
      "SITE_SETTINGS_LOADED_FAILURE"
    ]
  }
};